import React from 'react';
import {
  Box, Typography, Button, Paper, TextField, MenuItem,
  FormControl, InputLabel, Select, Chip,
} from '@mui/material';
import { MARKETS } from '../../../constants/markets';

interface StrategyStepProps {
  strategyType: string;
  market: string;
  amountPerTrade: number;
  onStrategyTypeChange: (value: string) => void;
  onMarketChange: (value: string) => void;
  onAmountChange: (value: number) => void;
  onNext: () => void;
  onBack: () => void;
}

const strategies = [
  { value: 'marktmeister', label: 'MarktMeister', desc: 'Adaptiver Bot — erkennt Marktphasen und passt Strategie automatisch an. Die beste Wahl.', recommended: true, experience: 'Erfahren' },
];

const markets = MARKETS;

const StrategyStep: React.FC<StrategyStepProps> = ({
  strategyType, market, amountPerTrade,
  onStrategyTypeChange, onMarketChange, onAmountChange,
  onNext, onBack,
}) => {
  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', py: 4 }}>
      <Typography variant="h5" gutterBottom fontWeight={700} textAlign="center">
        Deine erste Strategie
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 3 }}>
        Wähle eine Strategie, einen Markt und den Betrag pro Trade.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {strategies.map((s) => (
          <Paper
            key={s.value}
            onClick={() => onStrategyTypeChange(s.value)}
            sx={{
              p: 2, cursor: 'pointer', borderRadius: 2,
              border: 2,
              borderColor: strategyType === s.value ? 'primary.main' : 'divider',
              bgcolor: strategyType === s.value ? 'action.selected' : 'background.paper',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box>
                <Typography fontWeight={600}>{s.label}</Typography>
                <Typography variant="body2" color="text.secondary">{s.desc}</Typography>
              </Box>
              {s.recommended && <Chip label="Empfohlen" color="success" size="small" />}
            </Box>
          </Paper>
        ))}
      </Box>

      <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
        <FormControl fullWidth>
          <InputLabel>Markt</InputLabel>
          <Select value={market} label="Markt" onChange={(e) => onMarketChange(e.target.value)}>
            {markets.map((m) => (
              <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          fullWidth
          label="Betrag pro Trade (€)"
          type="number"
          value={amountPerTrade}
          onChange={(e) => {
            const val = Math.max(5, Math.min(Number(e.target.value), 10000));
            onAmountChange(val);
          }}
          inputProps={{ min: 5, max: 10000, step: 5 }}
          helperText="Minimum: 5€ — empfohlen: 1-5% deines Budgets"
          error={amountPerTrade < 5}
        />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
        <Button onClick={onBack}>Zurück</Button>
        <Button variant="contained" onClick={onNext}>Weiter</Button>
      </Box>
    </Box>
  );
};

export default StrategyStep;
